import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { BulkActionToolbar, CorrectionsModal, FullTable, ToastScreen } from 'components';
import {
  ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS,
  pendingPayableBatchesDetailsBody,
  pendingPayableBatchesDetailsHead, SEND_CORRECTION,
} from './constants';
import { LoadDetailSwitcher } from '../../loads';
import { AddPayoutDate } from './addPayoutDate';
import { MoveTo } from './moveTo';
import { FindError, FindSuccess, useModal, usePrimaryModal } from 'utils';
import {
  httpRequestsOnErrorsActions,
  httpRequestsOnLoadActions,
  httpRequestsOnSuccessActions,
  loadActions,
  LoadServices,
} from 'store';
import { LoadService } from '../../../fragments/loads/load.service';
import { PayableNotes } from './payableNotes';

export const PendingPayableBatchesDetails = ({ batch, getBatches, getTotals, onListInfoChange }) => {
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [showBulkAction, setShowBulkAction] = useState(false);
  const [correction, setCorrection] = useState('');
  const dispatch = useDispatch();
  const { loadsPayableBatches, batchesAllList } = useSelector((state) => ({
    loadsPayableBatches: state.loads.loadsPayableBatches,
    batchesAllList: state.loads.batchesAllList,
  }));
  const beckErrorSendCorrection = FindError(SEND_CORRECTION);
  const successCreatePayableNote = FindSuccess('CREATE_PAYABLE_NOTE');
  const successEditPayableNote = FindSuccess('EDIT_PAYABLE_NOTE');
  const successDeletePayableNote = FindSuccess('DELETE_PAYABLE_NOTE');
  const { open, close } = useModal();
  const { openPrimary, closePrimary, params } = usePrimaryModal();

  const totalFinalAmount = selectedLoads?.reduce((sum, load) => sum + LoadService.getPayableBalance(load?.payable), 0);

  useEffect(() => {
    const isEmpty = Object.keys(params).length === 0;

    setShowBulkAction(isEmpty);
  }, [params]);

  useEffect(() => {
    if (beckErrorSendCorrection?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(SEND_CORRECTION));

      toast(
        <ToastScreen
          type={'error'}
          text={'This action isn’t available right now for this load.'}
        />,
      );
    }

  }, [beckErrorSendCorrection?.[0]?.error]);

  useEffect(() => {
    if (successCreatePayableNote?.length || successEditPayableNote?.length || successDeletePayableNote?.length) {

      if (successCreatePayableNote?.length) {
        dispatch(httpRequestsOnSuccessActions.removeSuccess('CREATE_PAYABLE_NOTE'));
      }

      if (successEditPayableNote?.length) {
        dispatch(httpRequestsOnSuccessActions.removeSuccess('EDIT_PAYABLE_NOTE'));
      }

      if (successDeletePayableNote?.length) {
        dispatch(httpRequestsOnSuccessActions.removeSuccess('DELETE_PAYABLE_NOTE'));
      }

      if (batch?.id) {
        dispatch(loadActions.getLoadsPayableBatches(batch?.id, false));
      }
      close();
    }
  }, [successCreatePayableNote, successEditPayableNote, successDeletePayableNote]);

  useEffect(() => {
    if (batch?.id) {
      dispatch(loadActions.getLoadsPayableBatches(batch?.id));
    }
  }, [batch?.id]);


  const handleSelect = (e, item) => {
    setSelectedLoads((prevItems) => {
      const exists = prevItems.some((i) => i.id === item.id);
      if (exists) {
        return prevItems.filter((i) => i.id !== item.id);
      } else {
        return [...prevItems, item];
      }
    });
  };

  const handleSelectAll = (e, selectAll) => {
    if (e.target.checked || selectAll) {
      const allIds = loadsPayableBatches?.map(load => load);
      setSelectedLoads(allIds);
    } else {
      setSelectedLoads([]);
    }
  };


  const handleClick = (item) => {
    openPrimary(
      <CorrectionsModal
        handleChangeText={(value) => setCorrection(value)}
        actionType={SEND_CORRECTION}
        handleSend={() => handleSend(item?.id)}
        type={'notVerified'}
        handleClose={closePrimary}
      />);
  };

  const handleAddNote = (item) => {
    open(
      <PayableNotes
        load={item}
        afterSuccess={() => {
          close()
          if (batch?.id) {
            dispatch(loadActions.getLoadsPayableBatches(batch?.id, false));
          }
        }}
      />,
      { noPadding: true, noCloseButton: true }
    );
  };
  const handleSend = async (id) => {
    dispatch(httpRequestsOnLoadActions.appendLoading(SEND_CORRECTION));
    dispatch(httpRequestsOnErrorsActions.removeError(SEND_CORRECTION));
    try {
      const date = { 'correction': correction };
      await LoadServices.PayableCorrections(id, date);
      dispatch(loadActions.getLoadsPayableBatches(batch?.id));
      closePrimary();
      getBatches();
      getTotals();
    } catch (e) {
      dispatch(httpRequestsOnErrorsActions.appendError(SEND_CORRECTION, e?.data?.message));
    } finally {
      dispatch(httpRequestsOnLoadActions.removeLoading(SEND_CORRECTION));
    }
  };

  return (
    <div style={{ padding: '10px', background: '#E6ECF3' }}>
      <FullTable
        head={pendingPayableBatchesDetailsHead({
          handleSelectAll,
          list: loadsPayableBatches,
          currentList: selectedLoads,
        })}
        body={
          pendingPayableBatchesDetailsBody({
            batch,
            batchesList: batchesAllList?.batches?.filter((b) => b?.id !== batch?.id) || [],
            handleSelect,
            currentList: selectedLoads,
            clickRequestCorrection: handleClick,
            afterMoveSuccess: () => {
              getBatches();
              dispatch(loadActions.getLoadsPayableBatches(batch?.id, false));
              if (selectedLoads?.length) setSelectedLoads([]);
            },
            handleAddNote
          })}
        loadingType={ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS}
        onListInfoChange={onListInfoChange}
        list={loadsPayableBatches}
        fixHeight='45vh'
        margin={'0px'}
        handleClick={(id) =>
          openPrimary(<LoadDetailSwitcher loadId={id} />)
        }
        noText={'Pending Payable Batches'}
        padding={'8px'}
        paddingHead={'8px'}
      />

      {(!!selectedLoads?.length && showBulkAction) &&
        <BulkActionToolbar
          allAmount={totalFinalAmount}
          selectedCount={selectedLoads?.length}
          handleSelectOrUnselectAll={handleSelectAll}
          handleCreateBatch={() => openPrimary(
            <AddPayoutDate
              selectedLoads={selectedLoads}
              fromBatch={batch?.id}
              handleClose={closePrimary}
            />,
          )}
          handleMoveTo={() => openPrimary
          (
            <MoveTo
              selectedLoads={selectedLoads}
              batchesListFromBatches={batchesAllList?.batches?.filter((b) => b?.id !== batch?.id)}
              fromBatch={batch?.id}
              handleClose={closePrimary}
            />,
          )
          }
          isAllSelected={selectedLoads?.length === loadsPayableBatches?.length}
          handleClose={() => setSelectedLoads([])}
        />
      }
    </div>
  );
};

